import React from 'react';
import 'twin.macro';
import useFitText from 'use-fit-text';

interface Props {
  title: string;
  height?: number;
}

export function Slice({ title, height }: Props) {
  const { fontSize, ref } = useFitText();
  return (
    <th scope="row">
      <div
        tw="flex justify-center items-center whitespace-nowrap px-2"
        ref={ref}
        style={{ fontSize, height }}
      >
        {title}
      </div>
    </th>
  );
}
